var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCallHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25368_346301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.025 13.4875C8.825 17.025 11.725 19.925 15.2625 21.725L18.0125 18.975C18.3625 18.625 18.85 18.525 19.2875 18.6625C20.6875 19.125 22.1875 19.375 23.75 19.375C24.0815 19.375 24.3995 19.5067 24.6339 19.7411C24.8683 19.9755 25 20.2935 25 20.625V25C25 25.3315 24.8683 25.6495 24.6339 25.8839C24.3995 26.1183 24.0815 26.25 23.75 26.25C18.1141 26.25 12.7091 24.0112 8.72398 20.026C4.73883 16.0409 2.5 10.6359 2.5 5C2.5 4.66848 2.6317 4.35054 2.86612 4.11612C3.10054 3.8817 3.41848 3.75 3.75 3.75H8.125C8.45652 3.75 8.77446 3.8817 9.00888 4.11612C9.2433 4.35054 9.375 4.66848 9.375 5C9.375 6.5625 9.625 8.0625 10.0875 9.4625C10.225 9.9 10.125 10.3875 9.775 10.7375L7.025 13.4875Z",
    fill: "#E1292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 16.3656L18.3781 15.4581C14.8375 12.2475 12.5 10.1231 12.5 7.53125C12.5 5.40688 14.1638 3.75 16.2812 3.75C17.4775 3.75 18.6256 4.30687 19.375 5.18C20.1244 4.30687 21.2725 3.75 22.4688 3.75C24.5862 3.75 26.25 5.40688 26.25 7.53125C26.25 10.1231 23.9125 12.2475 20.3719 15.4581L19.375 16.3656Z",
    fill: "#E1292B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25368_346301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCallHelp);
export default __webpack_public_path__ + "static/media/icn_call_help.be8c3d55687849ec9fb22f1054d0725a.svg";
export { ForwardRef as ReactComponent };